import { render, staticRenderFns } from "./ProductCategoriesSelect.vue?vue&type=template&id=c517ef2c"
import script from "./ProductCategoriesSelect.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports